<template>
<div>
	<p>
<input type="file" @change="onFileChanged">
	</p>
	<p v-if="!this.fetched">
<button @click="onUpload" :disabled="upload">Upload!</button>
	</p>
<div>
	<div class="mt-2" v-if="error_loading.length > 0">
		I seguenti contributi risultano con errori sul mapping: {{ error_loading.toString() }}
	</div>
<div>
	<div class="mt-2" v-if="error_upload != ''">
		{{ error_upload }}
	</div>
</div>
<div class="mt-3 mb-2">	
<b-button v-b-toggle.collapse-1 variant="secondary" v-if="fetched">Vedi i dati caricati</b-button>
</div>
  <b-collapse id="collapse-1" class="mt-2">
    <b-card>
      <p class="card-text">
       <table-component :data="loadedData" ref="upload">
				<table-column :hidden="true" show="id" label="ID Farmer"></table-column>
				<table-column :hidden="true" show="CFTCDVOCONF" label="CFTCDVOCONF"></table-column>
				<table-column :hidden="true" show="CFTCDCONF" label="CFTCDCONF"></table-column>
				<table-column show="CFTDTCONF" label="Data Confez." data-type="date:DD/MM/YYYY"></table-column>
				<table-column show="CFTQTACONF" label="Quantità"></table-column>
				<table-column :hidden="true" show="VOCDESVOCONF" label="VOCDESVOCONF"></table-column>
				<table-column show="CNFRAG1" label="Rag. Sociale"></table-column>
				<table-column show="CNFSNOME" label="Rif. Interno"></table-column>
				<table-column show="TRASP.name" label="Vettore"></table-column>
       </table-component>
				</p>
    </b-card>
  </b-collapse>
</div>
</div>
</template>

<script>
import { abstractField } from 'vue-form-generator'
import axios from 'axios'
export default {
	mixins: [abstractField],
	data() {
	return {
		apiUrl: process.env.VUE_APP_IMPORT_API,
		selectedFile: null,
		loadedData: [],
		fetched: false,
		litri: 0,
		error_loading: [],
		upload: false,
		error_upload: ''
	}
	},
	methods: {
	onFileChanged (event) {
		this.selectedFile = event.target.files[0]
		this.fetched = false
		this.error_loading = []
	},
	onUpload() {
		this.$store.dispatch('remove_errorloading', [])
		const formData = new FormData()
		formData.append('myFile', this.selectedFile, this.selectedFile.name)
	// eslint-disable-next-line
	//console.log(formData.get('myFile'))
		this.upload = true
		axios.post(this.apiUrl + 'convert', formData)
      .then(response => {
				var response_X = response.data.Foglio1
			// Nome del foglio da settare qui!
				for (var x=0; x < response_X.length; x++) 
				{
				this.litri = this.litri + response_X[x].CFTQTACONF
				}
				for (var l=0; l < response_X.length; l++) 
				{
				var l_item = response_X[l]
					if (l_item.CNFSNOME === "BUFALARI PONTINI") {
						// eslint-disable-next-line
						return
						//console.log("Skipped line: ", l_item)
					}
					else {
					l_item.percentage = Math.round((l_item.CFTQTACONF / this.litri) * 1000)/10
					this.loadedData.push(l_item)
					if (typeof l_item.TRASP === 'undefined') {
						this.error_loading.push(l_item.CNFSNOME)
					}
					}
					
				}
				// eslint-disable-next-line
				//console.log("loadedData",this.loadedData)
				this.$store.dispatch('update_excel', this.loadedData)
				this.$store.dispatch('update_errorloading', this.error_loading)
				this.$refs.upload.refresh();
				this.fetched = true
			}).catch(error => {
				// eslint-disable-next-line
				console.error('Error uploading file:', error)
				this.error_upload = 'Errore durante il caricamento del file, controlla la correttezza del file e riprova'
				this.upload = false
				this.fetched = false
			})
			
    }
	}

}
</script>

<style lang="scss">
.vue-form-generator .field-image {
	.wrapper {
		width: 100%;
	}

	.preview {
		position: relative;
		margin-top: 5px;
		height: 100px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
		border: 1px solid #ccc;
		border-radius: 3px;
		box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);

		.remove {
			background-image: url("");
			width: 16px;
			height: 16px;

			font-size: 1.2em;

			position: absolute;
			right: 0.2em;
			bottom: 0.2em;
			opacity: 0.7;

			&:hover {
				opacity: 1;
				cursor: pointer;
			}
		}
	}
}
</style>
